const getters = {
  user: (state) => state.authModule.user,
  token: (state) => state.authModule.token,
  menuTree: (state) => state.permission.menuTree,
  hasPermission(state) {
    return (keyword) => {
      return state.permission.permissions.includes(keyword);
    };
  },
  checkedList: (state) => state.common.serverProject.checkedList,
  checkedPeople: (state) => state.common.serverProject.checkedPeople,
  osskey: (state) => state.oss.osskey,
  majorId: (state) => state.common.majorId,
  requestId: (state) => state.common.requestId,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js